export default {
  mobilePlanConfirmation: {
    id: 'bouygues_mobile_plan_confirmation_item_label',
    defaultMessage:
      'Your phone plan will be confirmed and created by Bouygues Telecom within 2 business hours.',
  },
}
